import { CheckCircle2, Copy } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { agentRunPrompt } from '../../lib/agent-jobs';
import type { JobType } from '../../types/api';
import { useToast } from '../ui/overlays';
import { Button } from '../ui/primitives';

export const AgentHandoff = ({ projectId, type, summary, onClose }: {
  projectId: string;
  type: JobType;
  summary: string;
  onClose: () => void;
}) => {
  const navigate = useNavigate();
  const toast = useToast();
  const prompt = agentRunPrompt(projectId, type);
  return (
    <div className="space-y-4">
      <div className="flex gap-3 rounded-lg border border-positive/20 bg-positive/5 p-4">
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-positive" />
        <div>
          <p className="font-semibold text-ink">{summary}</p>
          <p className="mt-1 text-[13px] text-muted">Ready for an agent to pick up. Queueing a job does not start an agent automatically.</p>
        </div>
      </div>
      <div>
        <p className="text-sm font-medium text-ink">Start the agent</p>
        <p className="mt-1 text-[13px] text-muted">Paste this into your agent connected to RentX. Connection instructions and progress are on Jobs.</p>
        <pre className="mt-3 whitespace-pre-wrap break-words rounded-lg bg-raised p-3 font-mono text-xs leading-relaxed text-muted">{prompt}</pre>
      </div>
      <div className="flex flex-wrap justify-end gap-2">
        <Button onClick={() => { onClose(); navigate(`/projects/${projectId}/jobs?type=${type}`); }}>View jobs</Button>
        <Button variant="primary" icon={<Copy className="h-4 w-4" />} onClick={async () => {
          try {
            await navigator.clipboard.writeText(prompt);
            toast.success('Agent prompt copied');
          } catch {
            toast.error('Could not copy. Select and copy the prompt above.');
          }
        }}>Copy agent prompt</Button>
      </div>
    </div>
  );
};
